import script from "./VideoPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPreview.vue?vue&type=script&setup=true&lang=js"

import "./VideoPreview.vue?vue&type=style&index=0&id=70cb8386&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70cb8386"]])

export default __exports__